import PolicyPage from "./PolicyPage";

export default function Privacy() {
    return <PolicyPage name="privacy" />;
}
